import { useQuery } from '@tanstack/react-query';
import { SocialMediaPostCounts, SocialMediaDailyCount } from '@/lib/api';
import { socialMediaApi } from '../api';
import { socialMediaQueryKeys } from '../api/queryKeys';

const DEFAULT_COUNTS: SocialMediaPostCounts = {
  total: 0,
  draft: 0,
  scheduled: 0,
  published: 0,
  failed: 0,
  cancelled: 0,
  publishing: 0,
};

/**
 * Fetches aggregate post counts and optional per-day activity for a
 * given Holder + month.
 *
 * @param holderId Holder ID from `useHolderSwitcher`. Null pauses the fetch.
 * @param month    Optional YYYY-MM string. When provided the hook
 *                 re-fetches whenever the month changes, returning daily
 *                 activity data for that month.
 */
export function useSocialPostStats(holderId: string | null, month?: string) {
  const query = useQuery({
    queryKey: socialMediaQueryKeys.stats(holderId ?? '', month),
    queryFn: () => socialMediaApi.getSocialMediaStats(holderId as string, month),
    enabled: !!holderId,
  });

  return {
    counts: query.data?.counts ?? DEFAULT_COUNTS,
    dailyActivity: (query.data?.dailyActivity ?? []) as SocialMediaDailyCount[],
    isLoading: query.isLoading,
    error: query.error instanceof Error ? query.error.message : null,
    /** Force a re-fetch of the current Holder + month. */
    loadStats: () => {
      void query.refetch();
    },
  };
}
